import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, TextField, Grid } from "@mui/material";
import * as sweetalert from "sweetalert";
import axios from "axios";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const FormAdd = ({ id, company,fundtype }) => {
  const [Voucher, setVoucher] = useState([]);
  const [Voucher_id, setVoucherId] = useState([]);
  const [Voucher_value, setVoucherValue] = useState([]);
  const [Voucher_price_admin, setVoucherPriceAdmin] = useState([]);
  const [formValues, setFormValues] = useState({
    fund_value: {
      value: "",
      error: false,
      errorMessage: "You must enter  fund value",
    },
    fund_price_for_client: {
      value: "",
      error: false,
      errorMessage: "You must enter  fund price",
    },
    fund_price_for_general_distributor: {
      value: "",
      error: false,
      errorMessage: "You must enter  fund price",
    },
    fund_price_for_special_distributor: {
      value: "",
      error: false,
      errorMessage: "You must enter  fund price",
    },
    fund_profit: {
      value: "",
      error: false,
      errorMessage: "You must enter  fund profit",
    },
    fund_price_for_admin: {
      value: "",
      error: false,
      errorMessage: "You must enter  fund price for admin",
    },
    voucher_id: {
      value: "",
      error: false,
      errorMessage: "You must enter  voucher id",
    },
  });
  const fundName = fundtype.map((element) => {
    if (element["p"].id === id) {
      return element["p"].fund_name;
    }
  });
  const filteredFundName = fundName.filter((value) => value !== undefined);
  useEffect(() => {
    axios
      .get(
        `${BaseUrl}/api/getAllVoucherList`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setVoucher(res.data.vouchersList);
      });
  }, []);
  const handelChangeValue = (e) => {
    const selectedId = parseInt(e);
    setVoucherValue(selectedId);
    setFormValues({ ...formValues, fund_value: selectedId });
    const filteredVouchers = Voucher.filter(
      (voucher) => voucher.voucherAmount === selectedId
    );
    filteredVouchers.map((e) => {
      setVoucherPriceAdmin(e.totalAmount);
      setFormValues({ ...formValues, fund_price_for_admin: e.totalAmount });
      setFormValues({ ...formValues, voucher_id: e.voucherId });
      setVoucherId(e.voucherId);
    });
  };

  const onSubmit = (event) => {
    event.preventDefault();
    const config = {
      headers: {
        Accept: "application/json",
        Authorization: null,
        sameSite: "strict",
      },
    };
 if(filteredFundName == "وحدات MTN" || filteredFundName =="MTN كاش" ||  filteredFundName =="Syriatel كاش" ){
      const data = [
        {
          fund_value: formValues.fund_value,
          fund_price_for_client: formValues.fund_price_for_client,
          fund_price_for_general_distributor:
            formValues.fund_price_for_general_distributor,
          fund_price_for_special_distributor:
            formValues.fund_price_for_special_distributor,
          fund_price_for_admin: formValues.fund_price_for_admin,
          voucher_id: "",
        },
      ];

      axios
        .get(
          `${BaseUrl}/sanctum/csrf-cookie`,
          config
        )
        .then((response) => {
          axios
            .post(
              `${BaseUrl}/api/addvaluesTofund/${id}`,
              data,
              {
                withCredentials: true,
              }
            )
            .then((res) => {
              if (res.status === 200) {
                sweetalert("تمت  الاضافة بنجاح", {
                  className: "alert-div",
                  button: {
                    text: "تم",
                  },
                }).then(window.location.reload());
              } else {
                sweetalert("error");
              }
            });
        });
    }
  
  else     if (company === "syriatel" ||  filteredFundName != "MTN كاش" ||  filteredFundName != "Syriatel كاش") {
    const data = [
      {
        fund_value: Voucher_value,
        fund_price_for_client: formValues.fund_price_for_client,
        fund_price_for_general_distributor:
          formValues.fund_price_for_general_distributor,
        fund_price_for_special_distributor:
          formValues.fund_price_for_special_distributor,
        fund_price_for_admin: Voucher_price_admin,
        voucher_id: Voucher_id,
      },
    ];

    axios
      .get(
        `${BaseUrl}/sanctum/csrf-cookie`,
        config
      )
      .then((response) => {
        axios
          .post(
            `${BaseUrl}/api/addvaluesTofund/${id}`,
            data,
            {
              withCredentials: true,
            }
          )
          .then((res) => {
            if (res.status === 200) {
              sweetalert("تمت  الاضافة بنجاح", {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(window.location.reload());
            } else {
              sweetalert("error");
            }
          });
      });
  } 
  } 

  const handleChange = (e) => {
    e.persist();
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  return (
    <form onSubmit={onSubmit}>
      <div className="form-group">
        {filteredFundName == "وحدات Syriatel"  ? (
          <Grid container maxWidth="sm" spacing={2}>
            <Grid item md={6} xs={12}>
              <label>قيمة الرصيد</label>
              <div class="select">
                <select
                  className="form-control"
                  class="select-text select-fund-value"
                  name="payment_method"
                  onChange={(e) => handelChangeValue(e.target.value)}
                >
                  <option selected disabled>
                    اختر قيمة الرصيد
                  </option>
                  {Voucher.map((opts, i) => (
                    <option key={opts.id} value={opts.id}>
                      {opts.voucherAmount}
                    </option>
                  ))}
                </select>
                <span class="select-highlight"></span>
                <span class="select-bar"></span>
              </div>
            </Grid>
            <Grid item md={6} xs={12}>
              return (
              <TextField
                label="سعر للادمن"
                type="text"
                className="form-control"
                id="fund_price"
                name="fund_price_for_client"
                disabled
                onChange={handleChange}
                value={Voucher_price_admin}
              />
              );
            </Grid>
            <Grid item md={6} xs={12}>
              return (
              <TextField
                label="سعر الزبون"
                type="text"
                className="form-control"
                id="fund_price"
                name="fund_price_for_client"
                onChange={handleChange}
                value={formValues.fund_price_for_client.value}
              />
              );
            </Grid>

            <Grid item md={6} xs={12}>
              return (
              <TextField
                label="سعر الموزع العام"
                type="text"
                className="form-control"
                id="fund_price"
                name="fund_price_for_general_distributor"
                onChange={handleChange}
                value={formValues.fund_price_for_general_distributor.value}
              />
              );
            </Grid>
            <Grid item md={6} xs={12}>
              return (
              <TextField
                label="سعر الموزع الخاص"
                type="text"
                className="form-control"
                id="fund_price"
                name="fund_price_for_special_distributor"
                onChange={handleChange}
                value={formValues.fund_price_for_special_distributor.value}
              />
              );
            </Grid>
          </Grid>
        ) : filteredFundName =="MTN كاش" ||  filteredFundName =="Syriatel كاش"  ?(
          <Grid container maxWidth="sm" spacing={2}>
            <Grid item md={6} xs={12}>
              return (
              <TextField
                label=" قيمة الرصيد"
                type="text"
                className="form-control"
                id="fund_value"
                name="fund_value"
                onChange={handleChange}
                value={formValues.fund_value.value}
              />
              ),
            </Grid>
            <Grid item md={6} xs={12}>
              return (
              <TextField
                label="سعر للادمن"
                type="text"
                className="form-control"
                id="fund_value"
                name="fund_price_for_admin"
                onChange={handleChange}
                value={formValues.fund_price_for_admin.value}
              />
              ),
            </Grid>
            <Grid item md={6} xs={12}>
              return (
              <TextField
                label="سعر الزبون"
                type="text"
                className="form-control"
                id="fund_price"
                name="fund_price_for_client"
                onChange={handleChange}
                value={formValues.fund_price_for_client.value}
              />
              );
            </Grid>

            <Grid item md={6} xs={12}>
              return (
              <TextField
                label="سعر الموزع العام"
                type="text"
                className="form-control"
                id="fund_price"
                name="fund_price_for_general_distributor"
                onChange={handleChange}
                value={formValues.fund_price_for_general_distributor.value}
              />
              );
            </Grid>
            <Grid item md={6} xs={12}>
              return (
              <TextField
                label="سعر الموزع الخاص"
                type="text"
                className="form-control"
                id="fund_price"
                name="fund_price_for_special_distributor"
                onChange={handleChange}
                value={formValues.fund_price_for_special_distributor.value}
              />
              );
            </Grid>
          </Grid>
        ):(
          <Grid container maxWidth="sm" spacing={2}>
            <Grid item md={6} xs={12}>
              return (
              <TextField
                label=" قيمة الرصيد"
                type="text"
                className="form-control"
                id="fund_value"
                name="fund_value"
                onChange={handleChange}
                value={formValues.fund_value.value}
              />
              ),
            </Grid>
            <Grid item md={6} xs={12}>
              return (
              <TextField
                label="سعر للادمن"
                type="text"
                className="form-control"
                id="fund_value"
                name="fund_price_for_admin"
                onChange={handleChange}
                value={formValues.fund_price_for_admin.value}
              />
              ),
            </Grid>
            <Grid item md={6} xs={12}>
              return (
              <TextField
                label="سعر الزبون"
                type="text"
                className="form-control"
                id="fund_price"
                name="fund_price_for_client"
                onChange={handleChange}
                value={formValues.fund_price_for_client.value}
              />
              );
            </Grid>

            <Grid item md={6} xs={12}>
              return (
              <TextField
                label="سعر الموزع العام"
                type="text"
                className="form-control"
                id="fund_price"
                name="fund_price_for_general_distributor"
                onChange={handleChange}
                value={formValues.fund_price_for_general_distributor.value}
              />
              );
            </Grid>
            <Grid item md={6} xs={12}>
              return (
              <TextField
                label="سعر الموزع الخاص"
                type="text"
                className="form-control"
                id="fund_price"
                name="fund_price_for_special_distributor"
                onChange={handleChange}
                value={formValues.fund_price_for_special_distributor.value}
              />
              );
            </Grid>
          </Grid>
        )}
      </div>

      <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
        <Button
          type="submit"
          variant="contained"
          className="btn-submit"
          color="secondary"
        >
          حفظ
        </Button>
      </Grid>
    </form>
  );
};
export default FormAdd;
